module.exports = __webpack_public_path__ + "img/shield_unselected_dark.fc45cfd5.png";